import { render, staticRenderFns } from "./PlansPartnerForm.vue?vue&type=template&id=1faf6be0&scoped=true&"
import script from "./PlansPartnerForm.vue?vue&type=script&lang=js&"
export * from "./PlansPartnerForm.vue?vue&type=script&lang=js&"
import style0 from "./PlansPartnerForm.vue?vue&type=style&index=0&id=1faf6be0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf6be0",
  null
  
)

export default component.exports